export default "__VITE_ASSET__f80072a7__"